export const LAST_ACTIVE_STORAGE_KEY = 'user_inactivity_last_active';

/**
 * Default number of days of inactivity before a user is deactivated.
 * Used as fallback when the federation-specific value is not available.
 */
export const DEFAULT_INACTIVITY_DAYS = 90;

/**
 * Number of days before the deletion threshold during which
 * the user shows as "About to be deactivated"
 */
export const ABOUT_TO_DEACTIVATE_DAYS = 30;
